import { IDeviceSize } from '@checkout/device';
import { IItem, ITotals } from '@checkout/items';
import { ISteps, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { GiftWrap, NewsletterCheckbox, OrderMessage, ProductsList, Voucher } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import messages from './../../../i18n/base-en';
import { OrderSection, SectionHeader, Summary } from './../../presentational';
import * as Styles from './OrderSummary.scss';

interface IOwnProps {
  deviceSize: IDeviceSize;
}

interface IConnectedProps {
  items: IItem[];
  totals: ITotals;
  steps: ISteps;
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderSummary extends React.Component<Props, {}> {

  render() {
    const { deviceSize, items, totals, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            <div className={Styles.column}>
              <OrderSection blockFor="CheckoutProductsList">
                <div className={Styles.header}>
                  <SectionHeader title={formatMessage(messages.order_summary_label)} />
                </div>
                <ProductsList
                  items={items}
                  giftWrapProductId={checkoutContextConfig.ui.giftWrap.productId}
                  deviceSize={deviceSize}
                  initialMobileVisibleItems={checkoutContextConfig.ui.initialMobileVisibleItems}
                />
              </OrderSection>
              {checkoutContextConfig.ui.giftWrap.isEnabled &&
                checkoutContextConfig.ui.giftWrap.productId !== '' && (
                <OrderSection blockFor="GiftWrap" transparent={!deviceSize.md}>
                  <GiftWrap items={items} productId={checkoutContextConfig.ui.giftWrap.productId} />
                </OrderSection>
              )}
              {(checkoutContextConfig.ui.orderSummary.isVoucherVisible) && (
                <OrderSection blockFor="CheckoutVoucher" transparent={!deviceSize.md}>
                  <Voucher id="orderSummaryVoucherInput" />
                </OrderSection>
              )}
              {checkoutContextConfig.ui.additionalNotes.enabled && (
                <OrderSection blockFor="CheckoutOrderMessage" transparent={!deviceSize.md}>
                  <OrderMessage />
                </OrderSection>
              )}
              <OrderSection blockFor="CheckoutSummary" borderBottom={checkoutContextConfig.ui.orderSummary.isNewsletterVisible} transparent={!deviceSize.md}>
                <Summary totals={totals} />
              </OrderSection>
              {checkoutContextConfig.ui.orderSummary.isNewsletterVisible && (
                <OrderSection blockFor="NewsletterCheckbox" borderBottom={false} transparent={!deviceSize.md}>
                  <NewsletterCheckbox
                    id="cartFieldsData.newsletter"
                    name="cartFieldsData.newsletter"
                    reverse={true}
                    sendNewsletterValue={true}
                    checkoutContextConfig={checkoutContextConfig}
                  />
                </OrderSection>
              )}
            </div>
          </Fragment>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps>(
    (state: RootState) => ({
      items: state.checkout.selection.items,
      totals: state.checkout.selection.totals,
      steps: state.checkout.steps,
    }),
    {}
  )
)(OrderSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderSummary/OrderSummary.tsx